import { createSelector, createFeatureSelector } from '@ngrx/store';

import { MeasurementsState } from '../models/measurements.model';

export const getMeasurementsState = createFeatureSelector<MeasurementsState>('measurements');

export const getMeasurementOverview = createSelector(
  getMeasurementsState,
  (state: MeasurementsState) => state.measurementOverview,
);

export const getMeasurement = createSelector(
  getMeasurementsState,
  (state: MeasurementsState) => state.measurement,
);
